(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  var push = function (data) {
    window.dataLayer.push(data);
  };
  var $doc = $(document);

  if (window.tscUserRepository && window.tscUserRepository.getProfileUpdates) {
    window.tscUserRepository.getProfileUpdates(function (profile) {
      if (profile) {
        push({tscId: profile.tscId});
      }
    });
  }

  var downloadProductLookup = {
    '0': 'Snagit',
    '1': 'Camtasia',
    '2': 'Audiate',
    '3': 'Capture'
  };

  var downloadPlatformLookup = {
    '0': 'windows',
    '1': 'macos'
  };

  // Product Trial Download
  $doc.on('click', '.download-details-container a', function (e) {
    var $link = $(e.currentTarget);
    var isDownloadRedirect = /downloadredirect/i.test($link.prop('pathname'));
    if (!isDownloadRedirect) {
      return;
    }

    var params = (new URL($link.prop('href'))).searchParams;
    var searchParams = new URLSearchParams(params);
    var itemName = searchParams.get('product') || '';
    var platform = searchParams.get('platform') || '';

    push({
      'event': 'product_trial_download',
      'item_name': downloadProductLookup[itemName.toLowerCase()] || 'unknown',
      'platform': downloadPlatformLookup[platform.toLowerCase()] || 'unknown'
    });
  });

  // Login and Sign Up
  $(function () {
    if (sessionStorage.getItem('tscProfile') && !sessionStorage.getItem('loginEventPushed') && document.referrer) {
      push({
        event: 'login',
        method: 'standard',
        user_id: JSON.parse(sessionStorage.getItem('tscProfile')).tscId
      });
      sessionStorage.setItem('loginEventPushed', 'true');
    } else if (!sessionStorage.getItem('tscProfile')) {
      sessionStorage.removeItem('loginEventPushed');
    }
  });

  // Menu Navigation
  $doc.on('click', '.level-2 a', function (e) {
    var $currentTarget = $(e.currentTarget);
    var menuType = $currentTarget.closest('.level-1').children('a').text();
    var linkText = $currentTarget.find('.product-name').text();

    if (menuType && linkText) {
      push({
        event: 'menu_navigation',
        menu_type: menuType,
        link_text: linkText
      });
    }
  });

  // Quiz Start
  $doc.on('click', '.quiz-trigger', function (e) {
    var quizName = $(e.currentTarget).closest('.inner-wrapper').find('.h3').text();

    push({
      event: 'quiz_start',
      quiz_name: quizName
    });
  });

  // Quiz Step
  $doc.on('click', '.quiz .next', function (e) {
    if ($('.validation-message').text()) {
      return;
    }

    var quizId = $(e.currentTarget).closest('fieldset').prop('id');

    var step = parseInt($('.quiz-status').find('.counter').text(), 10);
    step = (step !== 1) ? step - 1 : 4;

    var quizInputs = $('#' + quizId).find('input');
    var firstType = quizInputs.attr('type'); // same as quizInputs.first().attr('type')

    var answer = quizInputs
      .filter('[type="' + firstType + '"]')
      .filter(function (i, el) {
        return el.checked;
      }).map(function (i, el) {
        return el.defaultValue;
      }).toArray();

    push({
      event: 'quiz_step',
      step: step,
      answer: answer
    });
  });

  // Quiz Submit
  if (location.pathname.includes('product-quiz-results.html')) {
    $(function () {
      var itemName;

      var revealedWrapper = $('div.tsc-big-tabs-pane.active .personalization-wrapper').filter(function (i, el) {
        return $(el).css('display') !== 'none';
      });

      var imageLinkArray = revealedWrapper.find('div.copy-wrapper img').prop('src').split('/');
      var imageFile = imageLinkArray[imageLinkArray.length-1].split('.')[0];
      switch (imageFile) {
        case 'camtasia-logo':
          itemName = 'Camtasia';
          break;
        case 'snagit-logo':
          itemName = 'Snagit';
          break;
        case 'snagit-camtasia-logo':
          itemName = 'Snagit and Camtasia';
          break;
      }

      push({
        event: 'quiz_submit',
        item_name: itemName
      });
    });
  }

  // Form Submit
  $doc.on('submit', 'form', function () {
    if (location.pathname !== '/'){
      push({
        event: 'form_submit',
        form_name: document.title
      });
    }
  });

  // Email List Subscription
  var trackEmailChanges = function (isUnsubscribe) {
    return function (e) {
      $('#email-preferences-form').find('.newsletter-block').each(function (i, el) {
        var newsletter = $(el);
        var initialState = newsletter.find(':hidden[name$=InitialState]').val().toLowerCase() === 'true';

        var currentState = isUnsubscribe ? false : newsletter.find(':checkbox[name$=CurrentState]').prop('checked');

        if (initialState !== currentState) {
          var beforeFirstParen = /^([^(]+)/;
          var listName = newsletter.find('label').text().match(beforeFirstParen)[0].trim();

          push({
            event: 'email_list_subscription',
            list_name: listName,
            email_list_opt_in: currentState
          });
        }
      });
    };
  };

  $doc.on('click', '.unsubscribe-from-all-button, #unsubscribe-from-all-button', trackEmailChanges(true));

  $doc.on('submit', '#email-preferences-form', trackEmailChanges(false));

  // Explore Courses
  if (location.pathname.includes('visual-communication-research.html')) {
    $doc.on( 'click', 'a[href*="academy.techsmith.com"]', function () {
      push({
        event: 'explore_courses'
      });
    });
  }

  // Find Reseller
  if (location.pathname.includes('/application/salescontact/resellers/')) {
    $doc.on('submit', '#enterprise-form', function () {
      var country = $('#Country').find('option:selected').text();

      push({
        event: 'find_reseller',
        reseller_country: country
      });
    });
  }

  // Chat event handlers
  $doc.on('chat_open chat_started chat_end', function (e) {
    var nameLookup = {
      chat_open: 'chat_open',
      chat_started: 'chat_start',
      chat_end: 'chat_end'
    };

    push({
      event: nameLookup[e.type]
    });
  });

  // CtaEvents
  var patterns = [
    'snagit',
    'camtasia',
    'screen-capture',
    'video-editor',
    'assets',
    'library',
    'audiate',
    'screencast',
    'knowmia',
    'video',
    'review',
    'bundle'
 ];

 var productLookup = {
    snagit: 'Snagit',
    'screen-capture': 'Snagit',
    camtasia: 'Camtasia',
    'video-editor': 'Camtasia',
    audiate: 'Audiate',
    snagitassets: 'Assets for Snagit',
    assetssnagit: 'Assets for Snagit',
    librarysnagit: 'Assets for Snagit',
    camtasiaassets: 'Assets for Camtasia',
    assetscamtasia: 'Assets for Camtasia',
    librarycamtasia: 'Assets for Camtasia',
    screencast: 'Screencast',
    knowmia: 'Knowmia',
    videoreview: 'Video Review',
    bundle: 'Bundle'
 };

  var matcher = new RegExp(patterns.join('|'), 'g');

  var getProductFromHref = function (href) {
    var matches = href.match(matcher) || [];
    return productLookup[matches.join('')];
  };

  var getLocation = function ($target, defaultLocation) {
    if ($target.closest('.navigation-bar').length) {
        return 'navigation bar';
    } else if ($target.closest('.global-nav-menu').length) {
        return 'header menu';
    } else if ($target.closest('.product-pricing-teaser-card').length) {
        return 'allproducts page';
    }
    return defaultLocation;
  };

  var pushCtaEvents = function (eventName, defaultCtaLocation) {
    return function (e) {
      var $target = $(e.currentTarget);
      var loc = getLocation($target, defaultCtaLocation);
      var product = getProductFromHref($target.prop('href').toLowerCase());

      if (product) {
        push({
            event: eventName,
            item_name: product,
            cta_location: loc
        });
      }
    };
  };

  // Buy Now link click handler
  $doc.on('click', 'a.buy-now, a[href*="store/"]', function (e) {
      var $target = $(e.currentTarget);
      var isNavigation = $target.closest('.product-nav-bar').length > 0;

      if (isNavigation) {
        push({
          event: 'menu_navigation',
          menu_type: 'license type nav bar',
          link_text: $target.text()
        });
      } else {
        pushCtaEvents('buy_now_cta_click', 'product overview page')(e);
      }
  });

  // Free Trial link click handler
  $doc.on('click', 'a.free-trial, a[href*="download/"]', pushCtaEvents('free_trial_cta_click', 'product overview page'));

  // Learn More link click handler
  var learnMoreClicks = [
    'a.learn-more',
    'div.product-pricing-teaser-card a:not([href*="store/"])',
    'li.nav-products a[href*=".html"]',
    'li.nav-products a[href*="library"]',
    'a[href*="screen-capture"]',
    'a[href*="video-editor"]'
  ];

  $doc.on('click', learnMoreClicks.join(', '), pushCtaEvents('learn_more_cta_click', 'header menu'));

  // Google Analytics Global Variables
  var docReadyPromise = $.Deferred();
  $(function () { docReadyPromise.resolve(); });

  var navLookup = {
    '.nav-products': 'product landing page',
    '.nav-produkte': 'product landing page',
    '.nav-\u88fd\u54c1': 'product landing page',
    '.nav-company': 'about',
    '.nav-unternehmen': 'about',
    '.nav-\u4f1a\u793e\u60c5\u5831': 'about',
    '.nav-solutions': 'solutions',
    '.nav-lsungen': 'solutions'
  };

  var downloadPattern = /^\/(download|telechargement|descargar)[-\/]/i;
  var logoPattern = /logo/i;

  var getContentGroup = function () {
    // home, about, product detail page, product landing page, checkout, download, solutions, other
    var deferred = $.Deferred();
    docReadyPromise.then(function () {
      if (location.pathname === '/') {
        return deferred.resolve('home');
      }

      if (/^\/store\//i.test(location.pathname) && /(cart|checkout|thankyou)/i.test(location.pathname)) {
        return deferred.resolve('checkout');
      }

      if (/^\/store\//i.test(location.pathname) && /(snagit|camtasia|bundle|audiate|screencast|assets)/i.test(location.pathname)) {
        return deferred.resolve('product detail page');
      }

      if (downloadPattern.test(location.pathname) && !logoPattern.test(location.pathname)) {
        return deferred.resolve('download');
      }

      var $body = $(document.body);
      var menuNav = $body.data('menu-nav');
      var lookedup = navLookup[menuNav];
      if (lookedup) {
        return deferred.resolve(lookedup);
      }

      return deferred.resolve('other');
    });

    return deferred.promise();
  };

  var getContentGroup2 = function () {
    // snagit, camtasia, audiate, snagit-assets, camtasia-assets, screencast
    var deferred = $.Deferred();
    docReadyPromise.then(function () {
      var assetsMatch = location.pathname.match(/^\/store\/(assets)\/(snagit|camtasia)/i);
      if (assetsMatch) {
        return deferred.resolve(assetsMatch[2].toLowerCase() + '-' + assetsMatch[1].toLowerCase());
      }

      var productMatch = /^\/store\//i.test(location.pathname) && location.pathname.match(/(snagit|camtasia|audiate|screencast)/i);
      if (productMatch) {
        return deferred.resolve(productMatch[1].toLowerCase());
      }

      if (/^\/store\/bundle/i.test(location.pathname)) {
        return deferred.resolve('snagit, camtasia');
      }

      var $body = $(document.body);
      var menuNav = $body.data('menu-nav');
      var submenuNav = $body.data('submenu-nav') || '';
      if (menuNav === '.nav-products' && !submenuNav) {
        // products page
        return deferred.resolve('snagit, camtasia, audiate, snagit-assets, camtasia-assets, screencast');
      }

      var submenuNavMatch = submenuNav.match(/snagit-assets|camtasia-assets|snagit|camtasia|audiate|screencast/gi);
      if (menuNav === '.nav-products' && submenuNavMatch) {
        return deferred.resolve(submenuNavMatch.join(', ').toLowerCase());
      }

      return deferred.resolve(null);
    });

    return deferred.promise();
  };

  var getLanguage = function () {
    var deferred = $.Deferred();

    if (/^de|de$/i.test(location.hostname)) {
      return deferred.resolve('german');
    }
    if (/^es|es$/i.test(location.hostname)) {
      return deferred.resolve('spanish');
    }
    if (/^fr|fr$/i.test(location.hostname)) {
      return deferred.resolve('french');
    }
    if (/^jp|jp$/i.test(location.hostname)) {
      return deferred.resolve('japanese');
    }
    return deferred.resolve('english');
  };

  var getUserType = function () {
    return window.tscUserRepository.getProfileAsPromise()
      .then(function (profile) {
        if (profile) {
          var sessionProfile = JSON.parse(sessionStorage.getItem('tscProfile'));
          if (sessionProfile && sessionProfile.tscId === profile.tscId && 'isCustomer' in sessionProfile) {
            return sessionProfile;
          }

          return $.getJSON('/store/api/v1/customer')
            .then(function (info) {
              if (profile.tscId === info.techSmithId) {
                var parsedProfile = JSON.parse(sessionStorage.getItem('tscProfile'));
                parsedProfile.isCustomer = info.isCustomer;
                sessionStorage.setItem('tscProfile', JSON.stringify(parsedProfile));

                return parsedProfile;
              }
              return null;
            });
        }
        return null;
      });
  };

  $.when(
    getContentGroup(),
    getContentGroup2(),
    getLanguage()).then(function (contentGroup, contentGroup2, language) {
      var data = {};

      // only set values when known
      if (contentGroup) {
        data.content_group = contentGroup;
      }
      if (contentGroup2) {
        data.content_group2 = contentGroup2;
      }
      if (language) {
        data.language = language;
      }
      push(data);
    });

  getUserType().then(function (profile) {
    if (!profile) {
      return;
    }

    push({
      user_id: profile.tscId,
      user_email: profile.hashedEmail,
      first_name: profile.hashedFirstName,
      last_name: profile.hashedLastName,
      user_type: profile.isCustomer ? 'customer' : 'prospect'
    });
  });
}());
